import * as React from 'react';

import './game-logo.styles.less';

export const GameLogo = (): JSX.Element =>
    <div className="sitegen-game-logo"></div>;

GameLogo.displayName = 'GameLogo';

export default GameLogo;
